import { ACTION_TYPES } from "../../actions/othertransactions/OrderActions"

const initialState = {
    itemDashboard: {},
    OrderListPage: {},
    OrderDetails: {},
    OrderReceiptsByOrder: [],
    receiptServicesFreeByOrder: [],
    SaveReceiptByOrder: {}
}
export const OrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.CLEAN_USER_PROFILE:
            return {
                ...state,
                itemDashboard: {},
                OrderListPage: {},
                OrderDetails: {},
                OrderReceiptsByOrder: [],
                receiptServicesFreeByOrder: [],
                SaveReceiptByOrder: {}
            }
        case ACTION_TYPES.FETCH_DASHBOARD_ORDER:
            return {
                ...state,
                itemDashboard: action.payload
            }
        case ACTION_TYPES.FETCH_ORDER_LIST_PAGE:
            return {
                ...state,
                OrderListPage: action.payload
            }
        case ACTION_TYPES.FETCH_ORDER_DETAILS:
            return {
                ...state,
                OrderDetails: action.payload
            }
        case ACTION_TYPES.FETCH_ORDER_RECEIPTS_BY_ORDER:
            return {
                ...state,
                OrderReceiptsByOrder:[...action.payload]
            }
        case ACTION_TYPES.FETCH_RECEIPT_SERVICES_FREE_BY_ORDER:
            return {
                ...state,
                receiptServicesFreeByOrder:[...action.payload]
            }
        case  ACTION_TYPES.FETCH_SAVE_RECEIPT_BY_ORDER: 
            return {
                ...state,
                SaveReceiptByOrder: action.payload
            }
        default:
            return state
    }
}